<template>
    <span class="fib inline-block" :class="`fi-${props.language}`"></span>
</template>

<script setup lang="ts">
import '/node_modules/flag-icons/css/flag-icons.min.css';

interface Props {
    language: string;
}

const props = withDefaults(defineProps<Props>(), {
    //
});
</script>

<style lang="scss" scoped>
// .fi {
//     width: 100%;
//     height: 100%;
// }
</style>
